const BUFFER = 2;

export const getWindowedEvents = (events, start, end) => {
    if (events.length === 0) {
        return events;
    }

    // events is sorted by step so binary search for start and end indices
    let low=0;
    let hi=events.length - 1;

    let matches = [];

    let mid = -1;
    let loops = 0;
    while (low <= hi) {
        loops++;
        mid=Math.floor((low + hi)/2);
        let event = events[mid];
        if (matched(event)) {
            break;
        }

        if (event.step < start) {
            low = mid + 1;
        } else if (event.step > start) {
            hi = mid - 1;
        } else {
            break;
        }
    }

    let count = 0;
    for (let i=mid; i < events.length; i++) {
        loops++;
        let event = events[i];
        if (matched(event, start, end)) {
            matches.push(event);
        } else if (++ count > BUFFER) {
            break
        }
    }

    count = 0;

    for (let i=mid-1; i >= 0; i--) {
        loops++;
        let event = events[i];
        if (matched(event, start, end)) {
            matches = [event, ... matches];
        } else if (++ count > BUFFER) {
            break;
        }
    }

    return matches;
};

const matched = (event, start, end) =>
      (event.step >= start &&
       event.step <= end) ||
      (event.step <= start &&
       event.step + event.duration >= end);
